import Heading from "./components/heading";
import Content from "./components/content";
import Footer from "./components/footer";
import Chatbot from "./components/chatbot";
function App() {
  return (
    <div className="App flex flex-col justify-center font-geist">
      <div className="flex flex-col relative py-8 px-4 w-full max-w-[900px] mx-auto">
        <Heading />
        <Content />
        <Footer />
        <Chatbot />
      </div>
    </div>
  );
}

export default App;
